// walletconnect origin domain
export const ORIGIN_DOMAIN = process.env.VUE_APP_WC_ORIGIN_DOMAIN;
